<template>
  <div class="hotspot-panel" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div v-if="lists.length == 0" class="hotspot-placeholder">暂无热点</div>
    <div v-else class="hotspot-list">
      <div class="item" v-for="item in lists" :key="item.id">
        <div class="icon-box">
          <img class="icon" :src="item.thumb_preview | thumbImage('', 60)" />
        </div>
        <div class="title">{{ item.title }}</div>
        <div class="operate v-row">
          <div class="btn" @click="positionHotspot(item)">定位</div>
          <div class="line">|</div>
          <div class="btn" @click="editHotspot(item)">修改</div>
          <div class="line">|</div>
          <el-popconfirm title="确认删除?" @onConfirm="deleteHotSpot(item)">
            <div slot="reference" class="btn" v-loading="item.deleteLoading">删除</div>
          </el-popconfirm>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <div class="btn btn-save" @click="addHotspot">新增热点</div>
      <div class="btn btn-cancel" @click="mutationSetTabActive('')">取消</div>
    </div>
    <header-hotspot-add-edit v-if="isShowAddEdit" :show.sync="isShowAddEdit" @success="addSuccess" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import headerHotspotAddEdit from './header-hotspot-add-edit';

export default {
  components: { headerHotspotAddEdit },

  data() {
    return {
      lists: [], //热点集合,
      isShowAddEdit: false,
      editData: null,
      loading: false,
    };
  },

  computed: {
    ...mapState('tour', ['krp', 'materialId', 'worksId']),
  },

  created() {
    this.getHotList();
  },

  methods: {
    ...mapMutations('tour', {
      mutationSetTabActive: 'SET_TAB_ACTIVE',
    }),

    ...mapActions('tour', {
      actionGetSceneDetail: 'getSceneDetail',
    }),

    //热点列表
    async getHotList() {
      this.loading = true;
      try {
        let res = await this.api.spot.lists({
          works_id: this.worksId,
          material_id: this.materialId,
        });
        this.lists = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //新增热点弹窗
    addHotspot() {
      this.editData = null;
      this.isShowAddEdit = true;
    },

    async addSuccess() {
      this.getHotList();
      this.actionGetSceneDetail({ worksId: this.worksId, materialId: this.materialId });
    },

    //删除热点
    async deleteHotSpot(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.spot.delete({ id: row.id });
        this.$message.success('删除成功');
        this.krp.call(`deletehotspot(${row.name}))`);
        this.getHotList();
        this.actionGetSceneDetail({ worksId: this.worksId, materialId: this.materialId });
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },

    //定位热点
    positionHotspot(row) {
      let fov = this.krp.get('view.fov');
      this.krp.call(`looktohotspot(${row.name},${fov},smooth())`);
    },

    //修改
    editHotspot(row) {
      this.krp.call(`js(krpjs.editHotSpot(${row.id}))`);
    },
  },
};
</script>

<style lang="scss" scoped>
.hotspot-panel {
  max-width: 350px;
}

.hotspot-panel {
  color: #fff;
}

.hotspot-list {
  padding: 10px;
  min-height: 200px;
  max-height: 500px;
  overflow-y: auto;
}

.hotspot-list .item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  padding: 10px;

  &:hover {
    border-color: #1e9fffcc;
  }
}

.hotspot-list .item .icon-box {
  width: 50px;
}

.hotspot-list .item .icon {
  display: block;
  height: 30px;
  max-width: 100%;
}

.hotspot-list .item .title {
  flex: 1;
  padding: 0 20px 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.hotspot-list .item .operate {
  font-size: 12px;
}

.hotspot-list .item .operate .line {
  margin: 0 3px;
}

.hotspot-list .item .operate .btn {
  cursor: pointer;
  user-select: none;

  &:hover {
    font-weight: bold;
  }
}

.hotspot-placeholder {
  padding: 100px;
  text-align: center;
}

.panel-footer {
  display: flex;
}

.panel-footer .btn {
  flex: 1;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

.panel-footer .btn-save {
  background: #006ab1;
}

.panel-footer .btn-cancel {
  background: #9e9e9e;
}
</style>
